
export default function search(motifs, dates, array, el){
    // if((date != null && date.filtre != undefined) && (motif != null && motif.description != undefined)){
    //     return arr.filter((ligne_temp) => {
    //         el = ligne_temp;
    //         return el.created_at.includes(date.filtre) && el.motif.id == motif.id
    //     })
    // }else{
    //     if(date != null && date.filtre != undefined){
    //     return arr.filter((el) => {
    //         return el.created_at.includes(date.filtre)
    //         })
    //     }
    //    if(montant != null && montant.filtre != undefined){
    //         return arr.filter((el) => {
    //             return el.validations.includes(montant.filtre)
    //         })
    //     }
    //     if(motif != null && motif.description != undefined){
    //         return arr.filter(el => el.id == motif.id)
            
    //     }
    // }
    // return arr;

    const query = motifs.toLowerCase();
    const req = dates;
    if(motifs === "" && dates === null){
        return array;
    }else{
        if(motifs !== ""){
            return array.filter((ligne_temp) => {
                el = ligne_temp;
                return el.motif.toLowerCase().includes(query)
            })
        }
        // if(activites !== ""){
        //     const queryA = activites.toLowerCase();
        //     el = ligne_temp;
        //     return el.activites_medecin_referent.description_fr.toLowerCase().includes(queryA)
        // }
        if(dates !== null){
            return array.filter((ligne_temp) => {
                el = ligne_temp;
                return el.created_at.includes(req)
            })
            
        }
    }
}
